export default "__VITE_ASSET__BDjShp7M__"